import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/consumer/Link';
const PDPDiscontinuedMessage = t0 => {
  const $ = _c(3);
  const {
    discontinuedCategoryMsg
  } = t0;
  if (!discontinuedCategoryMsg?.category) {
    return "Sorry, this product has been discontinued.";
  }
  let t1;
  if ($[0] !== discontinuedCategoryMsg.category || $[1] !== discontinuedCategoryMsg.link) {
    t1 = <>Sorry, this product has been discontinued. Discover other stylish{" "}<Link to={discontinuedCategoryMsg.link}>{discontinuedCategoryMsg.category}</Link></>;
    $[0] = discontinuedCategoryMsg.category;
    $[1] = discontinuedCategoryMsg.link;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
PDPDiscontinuedMessage.propTypes = {
  discontinuedCategoryMsg: PropTypes.shape({
    category: PropTypes.string,
    link: PropTypes.string
  })
};
export default PDPDiscontinuedMessage;